export default __webpack_public_path__ + "static/media/headerBG01.5cb824ec.png";